<template>
    <div id="view" :class="modalTheme">
<!-- <span style="color:red;"> bModalTheme:    {{ modalTheme }}
  userStore.borderClass {{ userStore.borderClass }}</span> -->
    </div>
  <div  :class="modalTheme">
  <!-- <div :class="devExTheme === 'generic.light' ? 'generic-light-border' : 'generic-dark-border'"> -->
    <!-- devExTheme {{ devExTheme }} -->
    <b-container fluid class="d-flex justify-content-end" :class="userStore.borderClass">
      <b-row>
        <!-- <h6>DASHBOARD INFO BAR</h6> -->
        <!-- <div></div> -->
        <!-- <b-col cols="*" class="d-flex justify-content-start patientSection w3-leftbar">LEFT</b-col> -->
        <b-col style="background: transparent; padding: 0px; padding-right: 30px" v-if="[8, 9, 3, 15].some((id) => workListStore.taskRecords[id])">
          <b-row style="background: transparent; padding: 0px; padding-right: 30px">
            <!-- <h4>BADGE build to worklistStore Tasks </h4> -->
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="workListStore.taskRecords[8]" v-show="workListStore.taskRecords[8].length > 0" pill variant="inspinia">
                Tasks {{ workListStore.taskRecords[8].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="workListStore.taskRecords[9]" v-show="workListStore.taskRecords[9].length > 0" pill variant="inspinia">
                Delegated Tasks: {{ workListStore.taskRecords[9].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="workListStore.taskRecords[3]" v-show="workListStore.taskRecords[3].length > 0" pill variant="inspinia">
                Non Patient Tasks: {{ workListStore.taskRecords[3].length }}
              </b-badge>
            </b-col>
            <b-col cols="*">
              <b-badge :class="modalTheme" v-if="workListStore.taskRecords[15]" v-show="workListStore.taskRecords[15].length > 0" pill variant="inspinia">
                Non Patient Assigned: {{ workListStore.taskRecords[15].length }}
              </b-badge>
            </b-col>
          </b-row>
        </b-col>

        <div style="background: darkred; padding: 5px" v-if="[1, 10, 11].includes(taskbuilderStore.taskRecords.id)">
          <b-col cols="*">
            <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[1]" v-show="taskbuilderStore.taskRecords[1].length > 0" pill variant="inspinia">
              Problems: {{ taskbuilderStore.taskRecords[1].length }}
            </b-badge>
          </b-col>
          <b-col cols="*">
            <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[10]" v-show="taskbuilderStore.taskRecords[10].length > 0" pill variant="inspinia">
              Meds: {{ taskbuilderStore.taskRecords[10].length }}
            </b-badge>
          </b-col>
          <b-col cols="*">
            <b-badge :class="modalTheme" v-if="taskbuilderStore.taskRecords[11]" v-show="taskbuilderStore.taskRecords[11].length > 0" pill variant="inspinia">
              Labs: {{ taskbuilderStore.taskRecords[11].length }}
            </b-badge>
          </b-col>
        </div>

        <b-col cols="*" class="d-flex justify-content-end">
          <!-- <h6>CreateNewDashTaskSidebar</h6> -->
          <!-- <br /> -->
          <CreateNewDashTaskSidebar class="mx-auto mb-2" :context="context" :records="workListStore.getAllDashTaskRecords" :disabled="false" @clearWorkListRecords="clearWorkListRecords" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

// * STOREs
import { useStoreTaskBuilder } from "@/stores/taskBuilderStore";
const taskbuilderStore = useStoreTaskBuilder();
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();

import CreateNewDashTaskSidebar from "@/modules/Messaging/CreateNewDashTaskSidebar.vue";
import { fetchMyWorkDetails } from "@/api/workListsApi";

import { toast } from "vue3-toastify";

import momentJ from "moment/moment";
import { extendMoment } from "moment-range";
var moment = extendMoment(momentJ);

import { useRoute, useRouter } from "vue-router";
// & ROUTER
const route = useRoute();
const router = useRouter();
// & PROPS
const props = defineProps({
  showPatients: {
    Type: Boolean,
    Default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);
// const devExTheme = computed(() => userStore.devExTheme);

const AreIdsShown = ref(true);
const myWorkTasksFromStore = ref([]);
const context = {
  location: "Context.Demographics",
  title: "Create Dash Task/Message",
};

// const fetchMyWorkDetails = ref(null);

// currentDate: moment(Date.now()).format('YYYY-MM-DD'),
// 			myWorkTasksFromStore: [],
// 			toggled: false,
// 			pDoB: moment().format('YYYY-MM-DD'),
// 			// showPatients: null,
// 			sPeople: true,
// 			fetchMyWorkDetails,
// 			context: {
// 				location: 'Context.Demographics',
// 				title: 'Create Task/Message',
// 			},

// * ADD FUNCTIONs
function clearWorkListRecords() {
  // this.$store.state["workLists"].taskRecords = [];
  // console.dir(this.$store.state['workLists'].taskRecords)
  workListStore.taskRecords = [];
  // console.log(" RUNNING 				this.reloadRoute() .......................");
  reloadRoute();
}
function reloadRoute() {
  // console.log("				reloadRoute");
  // console.log('											this.$router.go(this.$router.currentRoute)')
  // console.log('GO >')
  // console.log('GO > router.currentRoute.value.fullPath: ', router.currentRoute.value.fullPath)
  // this.$router.go(this.$router.currentRoute);

  // console.log("NEW >>> 0626 >>>> reloadRoute");
  // Reload the current route
  // router.replace({ path: router.currentRoute.value.fullPath, query: router.currentRoute.value.query });
  // Or, to force a full reload:
  // router.go(0);
  // router.push({ path: router.currentRoute.value.fullPath, query: router.currentRoute.value.query });
  // router.push("/Dashboard/Primary");
  // router.push("/Dashboard/MyWork");
  // router.push("/Home");
  // console.log("                   getWidgetSummaryListFromAPI   ");
  workListStore.getWidgetSummaryListFromAPI();
}
async function onChangeShowPatients() {
  this.showPatients = !this.showPatients;
  //// //console.clear()()
  // // console.log('this.showPatients: ', this.showPatients)

  this.$emit("showPatients", this.showPatients);
}
function hoverHandler(isHovered) {
  if (isHovered) {
    // // console.log('hoverHandler(isHovered): ', isHovered)
    this.onChangeShowPatients();
    // Do something
  } else {
    // Do something else
    // // console.log('hoverHandler(isHovered): ', isHovered)
  }
}
function shown(e) {
  // // console.log('show')

  this.pDoB = patient.dateOfBirth;
  // // console.log('THIS pDOB : ', this.pDoB)
}

onMounted(() => {
  // console.log("onMounted() :      Dashboard INFO BAR      TODO     >>>>");
  // this.myWorkTasksFromStore = []
  // this.myWorkTasksFromStore = workListStore.getMyWorkTaskRecords
  // console.log("  					DASHINFO:  myWorkTasksFromStore");
  // console.dir(this.myWorkTasksFromStore)
  // toast.warning(' DIG OUT        this.getUsersFilters')
  // var uFilters = this.getUsersFilters()
  // console.log('  					DASHINFO:  uFilters')
  // console.dir(uFilters)
  // console.log("ROUTE : ", route);
  // console.log("ROUTE : Path ", route.path);
  // console.log(" route.name: ", route.currentRoute.value.name);
});
</script>

<style scoped>
.dInfoBar {
  /* width: 420px; */
  border-radius: 5px;
  background-color: transparent;
  color: transparent;
  border: 1px solid red;
  width: 100%;
  height: 25px;
}

.card-header {
  padding: 0%;
  height: 36px;
}

.dashInfo {
  border: 1px solid #0f8cc5 !important;
  padding: 0px 0px 0px 15px;
  border-radius: 5px;
  background-color: #dcf1de !important;
  color: lime;
}

.btn-dark-green:hover {
  color: rgb(125, 248, 125);
  background-color: #092522;
  border-color: #02fae1;
}

.bg-dark {
  background-color: #07251f !important;
  color: rgb(125, 248, 125);
}

h6 {
  font-size: 0.875rem;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
}
</style>
